import React, { useState } from 'react';

export const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-[100dvh] flex flex-col font-sans text-primary bg-bg-page">
      <header className="bg-bg-card shadow-sm border-b border-primary/10 sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center relative">
          <div className="flex items-center gap-2">
            <h1 className="text-xl md:text-2xl font-serif font-bold text-primary tracking-wide">
              Psicanalista <span className="text-accent">Gisela Serra</span>
            </h1>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-1">
            <a href="#/" className="text-primary hover:text-accent px-3 py-2 rounded-md hover:bg-primary/5 font-medium transition-colors text-sm">Agendar</a>
            <a href="#/tracking" className="text-primary hover:text-accent px-3 py-2 rounded-md hover:bg-primary/5 font-medium transition-colors text-sm">Meus Agendamentos</a>
            <div className="h-4 w-px bg-gray-300 mx-2"></div>
            <a href="#/admin" className="text-sm text-primary/60 hover:text-primary px-3 transition-colors">Acesso Restrito</a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-primary p-2 focus:outline-none"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <span className="text-2xl">{isMenuOpen ? '✕' : '☰'}</span>
          </button>

          {/* Mobile Nav Dropdown */}
          {isMenuOpen && (
            <div className="absolute top-full left-0 w-full bg-white border-b border-gray-200 shadow-lg md:hidden animate-slide-in flex flex-col z-50">
              <a
                href="#/"
                className="block px-6 py-4 border-b border-gray-100 hover:bg-gray-50 text-primary font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Agendar Consulta
              </a>
              <a
                href="#/tracking"
                className="block px-6 py-4 border-b border-gray-100 hover:bg-gray-50 text-primary font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Meus Agendamentos
              </a>
              <a
                href="#/admin"
                className="block px-6 py-4 hover:bg-gray-50 text-gray-400 text-sm"
                onClick={() => setIsMenuOpen(false)}
              >
                🔒 Acesso Restrito
              </a>
            </div>
          )}
        </div>
      </header>

      <main className="flex-grow container mx-auto w-full flex flex-col justify-center px-4 py-8">
        {children}
      </main>

      <footer className="bg-primary text-white py-6 mt-auto">
        <div className="container mx-auto px-4 text-center">
          <img
            src="https://i.ibb.co/KcBy4mtW/GSPsicanalise-Logo-Nova.png"
            alt="Logo Gisela Serra"
            className="h-32 w-auto mx-auto mb-3 object-contain"
          />
          <div className="flex flex-col md:flex-row justify-center items-center gap-1 md:gap-2 text-xs text-white/90">
            <p>© {new Date().getFullYear()} Psicanalista Gisela Serra. Todos os direitos reservados.</p>
            <span className="hidden md:inline">•</span>
            <p>
              Criado por <a href="https://brnsolucaotecnologica.com.br/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-white underline underline-offset-2 transition-colors font-medium">BRN Solução Tecnológica</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};
